import { Size } from '../../../styles/theme.mjs';
import { StyledText } from '../../Typography/Text/Text.styles.mjs';
import StyledLink from '../Link/Link.mjs';
import styled, { css } from 'styled-components';

const categoryTextCss = css `
  margin: 0;
  display: flex;
  gap: ${props => (props.withArrow ? '0.6rem' : 0)};
  position: relative;
  text-transform: ${props => (props.uppercased ? 'uppercase' : 'none')};
  padding-left: ${props => (props.withMarker ? '11px' : 0)};
  transition-property: gap;
  transition-duration: ${props => props.theme.animation.duration.moderate1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
  line-height: ${props => { var _a; return props.theme.typography.text[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Medium].lineHeight; }};
  color: ${props => props.theme.colors.categoryTextColor};
  font-size: ${props => { var _a; return props.theme.typography.text[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Medium].fontSize; }};
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
  ${props => props.withMarker &&
    css `
      &::before {
        content: '';
        position: absolute;
        top: 1px;
        left: 0;
        width: 5px;
        height: calc(100% - 4px);
        background-color: ${props => props.theme.colors.skyBlue};
      }
    `};
`;
const StyledCategoryText = styled(StyledText) `
  ${categoryTextCss}
`;
const StyledCategoryLink = styled(StyledLink) `
  ${categoryTextCss};

  @media (pointer: fine) {
    &:hover {
      color: ${props => props.hoverColor ? props.hoverColor : props.theme.colors.categoryTextColor};
      gap: ${props => (props.withArrow ? '1.2rem' : 0)};
    }
  }
`;
const IconWrapper = styled.div `
  display: inline-block;
  padding-top: ${props => (props.uppercased ? '1px' : '2px')};
`;

export { IconWrapper, StyledCategoryLink, StyledCategoryText };
//# sourceMappingURL=CategoryTitle.styles.mjs.map
